import * as _ from "underscore";

// interface Win extends Window {
//     SFLY_DTL: any;
//     adobeDynamicTagManagementDataMapper(dtlValueObj, namespace): void;
//     s: any;
// }
// declare var window: Win;

export interface IPageInfo {
    vistorId: string;
    vistorType: string;
    siteExperience: string;
}

export interface IProductInfo {
    sku: string;
}

export class DtlManager {
    constructor() {
        _.mixin({
            merge: (...args) => {
                return _.reduce(args, (list, obj) => {
                    return _.extend(list, obj);
                }, {});
            },
        });
    }

    /** clearDTLVars
     * Removes all variables in list from the DTL layer
     */
    public clearDTLVars(propertyList?: string[]) {
        if (typeof (propertyList) === "undefined" ||
            typeof(window.SFLY_DTL) === "undefined") {
            window.SFLY_DTL = {};
            return;
        }

        function traceContext(context: string, searchObject: object) {
            let propertyName: string = context;
            const delimiterPosition = context.indexOf(".");
            const tracedObject = searchObject;

            if (delimiterPosition > -1) {
                propertyName = context.slice(0, delimiterPosition);
            }

            // validate context
            if (searchObject.hasOwnProperty(propertyName) === false) {
                return tracedObject;
            }

            if (context.indexOf(".") > -1) {
                if (typeof (searchObject[propertyName]) === "object") {
                    tracedObject[propertyName] = traceContext(
                        context.slice(delimiterPosition + 1, context.length),
                        searchObject[propertyName],
                    );
                }
            } else {
                delete searchObject[context];
            }

            return tracedObject;
        }

        if (_.isArray(propertyList)) {
            propertyList.forEach((context) => {
                traceContext(context, window.SFLY_DTL);
            });
            return;
        }

        // path will never be executed due to type requirement but that may change that
        if (_.isString(propertyList)) {
            traceContext(propertyList, window.SFLY_DTL);
            return;
        }
    }

    /** clearSVars
     * Removes all the variables in list from the S object.  Blank to delete entire object.
     */
    public clearSVars(propertyList?: string[]) {
        if (typeof (propertyList) === "undefined") {
            window.s.clearVars();
        } else {
            window.s = _.omit(window.s, propertyList);
        }
    }

    public putSVar(propertyName: string, value: any) {
        window.s[propertyName] = value;
    }

    public putDtlVar(propertyName: string, value: any, doNotClobber: boolean = false) {
        // places value inside of the namespace
        function makeContext(context: string, parentObject: object): object {
            if (context !== "") { // context is not a root
                let objectName: string = context;
                let returnObject = parentObject;
                const delimiterPosition = context.indexOf(".");

                if (delimiterPosition > -1) {
                    objectName = context.slice(0, delimiterPosition);
                    parentObject[objectName] = {};
                    returnObject = makeContext(
                        context.slice(delimiterPosition + 1, context.length),
                        parentObject[objectName],
                    );
                } else {
                    parentObject[objectName] = value;
                }
            } else { // context is point to root
                if (typeof (value) === "object") { // if the value is an object than return this as the object
                    parentObject = value;
                } else {
                    console.error(
                        "sflyBridge:",
                        "putDtlVar:",
                        " root object was specified as context but value was not an object.",
                    );
                }
            }

            return parentObject;
        }

        const newObject = makeContext(propertyName, {});
        if (doNotClobber) {
            window.SFLY_DTL = this._merge(newObject, window.SFLY_DTL);
        } else {
            window.SFLY_DTL = this._merge(window.SFLY_DTL, newObject);
        }
    }

    public getSVar(propertyName: string) {
        return window.s[propertyName];
    }

    public getDtlVar(propertyName: string) {
        return window.SFLY_DTL[propertyName];
    }

    /*
     * Recursively merge properties of two objects
     */
    private _merge(obj1, obj2) {

        if (typeof(obj2) === "undefined") {
            return obj1;
        }

        if (typeof(obj1) === "undefined") {
            return obj2;
        }

        for (const p in obj2) {
            // Property in destination object set; update its value.
            if (obj2[p].constructor === Object) {
                if (typeof(obj1[p]) === "undefined" || obj1[p].constructor !== Object) {
                    obj1[p] = obj2[p];
                } else {
                    obj1[p] = this._merge(obj1[p], obj2[p]);
                }
            } else {
                obj1[p] = obj2[p];
            }
        }

        return obj1;
    }

}
